import React, { useState } from "react";
import "./AddLocationForm.css"; // Ensure proper styling

const AddLocationForm = ({ onClose, onLocationAdded }) => {
  const [formData, setFormData] = useState({
    location_name: "",
    address: "",
    status: "IN",
  });

  const [error, setError] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.location_name || !formData.address || !formData.status) {
      setError("All fields are required.");
      return;
    }

    try {
      const response = await fetch("/api/locations/add-location", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to add user.");
      }

      alert("✅ Location added successfully!");
      setTimeout(() => {
        onLocationAdded(); // Refresh user list
        onClose(); // Close modal
      }, 300);
    } catch (error) {
      console.error("❌ Error adding location:", error.message);
      setError(error.message || "An error occurred.");
    }
  };

  return (
    /** ✅ Wrap everything in a <div> to avoid ESLint error */
    <div className="modal-overlay">
      <div className="modal-content">
        {/* Close Button */}
        <button className="close-button" onClick={onClose}>✖</button>

        <h3>Add Location</h3>

        <form onSubmit={handleSubmit}>

          <div className="form-group">
            <label id="add-user-label">Location Name:</label>
            <input id="add-user-input" type="text" name="location_name" value={formData.location_name} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label id="add-user-label">Address:</label>
            <input id="add-user-input" type="text" name="address" value={formData.address} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label id="add-user-label">Status:</label>
            <select id="add-user-input"
              name="status"
              value={formData.status}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                Select Type
              </option>
              <option value="IN">IN</option>
              <option value="OUT">OUT</option>
            </select>
          </div>          
            {/* Display error message */}
          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="submit-btn">Add Location</button>
        </form>
      </div>
    </div>
  );
};

export default AddLocationForm;
